<template>
  <div>
    <!-- QFM查詢 -->
    <CCard class="w-100">
      <CCardHeader>
        <strong>QFM</strong>
      </CCardHeader>
      <CCardBody>
        <CForm>
          <div class="CForminline">
            <div>
              <p>{{ $t("QuoteInfo_Vue.FactoryType") }}：</p>
              <div
                v-for="(item, key) in factoryList"
                :key="'factoryType_input_' + key"
              >
                <input
                  type="radio"
                  :name="'coa_FactoryTypeOpt'"
                  v-model="searchParam.Factory"
                  :value="item.factoryId"
                  :disabled="disableFactory"
                />{{ getFactoryCaption(item.factoryId, item.factoryCaption) }}
              </div>
            </div>

            <div>
              <p>{{ $t("QFM_Vue.QFMNo") }}：</p>
              <input type="text" maxlength="15" v-model="searchParam.QFMNo" />
            </div>

            <div>
              <p>{{ $t("QFM_Vue.Supplier") }}：</p>
              <input
                style="width: 300px"
                type="text"
                v-if="disableCusName_input"
                :disabled="true"
                v-model="searchParam.VendorId"
              />
              <Select2
                style="width: 300px"
                v-if="!disableCusName_input"
                v-model="searchParam.VendorId"
                :options="memberListFilter()"
                :settings="{
                  multiple: false,
                  dropdownAutoWidth: true,
                  width: '100%',
                  allowClear: true,
                }"
              />
            </div>

            <div>
              <p>{{ $t("QFM_Vue.StartDate") }}：</p>
              <date-picker
                :lang="'zh-tw'"
                v-model="searchParam.StartDateStart"
                format="YYYY-MM-DD"
                valueType="format"
              ></date-picker>
              <span>~</span>
              <date-picker
                :lang="'zh-tw'"
                v-model="searchParam.StartDateEnd"
                format="YYYY-MM-DD"
                valueType="format"
                :disabled-date="
                  (date) =>
                    date.addDays(1, 'day') <=
                    new Date(searchParam.StartDateStart)
                "
              ></date-picker>
            </div>

            <div>
              <p>{{ $t("QFM_Vue.MaterialNo") }}：</p>
              <input
                type="text"
                maxlength="15"
                class="mr-5"
                v-model="searchParam.MaterialNo"
              />
            </div>

            <div>
              <p>{{ $t("QFM_Vue.OrderNo") }}：</p>
              <input type="text" maxlength="15" v-model="searchParam.PONo" />
            </div>

            <div>
              <p>{{ $t("QFM_Vue.ProduceDate") }}：</p>
              <date-picker
                :lang="'zh-tw'"
                v-model="searchParam.ProduceDateStart"
                format="YYYY-MM-DD"
                valueType="format"
              ></date-picker>
              <span>~</span>
              <date-picker
                :lang="'zh-tw'"
                v-model="searchParam.ProduceDateEnd"
                format="YYYY-MM-DD"
                valueType="format"
                :disabled-date="
                  (date) =>
                    date.addDays(1, 'day') <=
                    new Date(searchParam.ProduceDateStart)
                "
              ></date-picker>
            </div>

            <div>
              <p>{{ $t("QFM_Vue.Status") }}：</p>
              <div
                v-for="(item, key) in qfmStatusList"
                :key="'coa_RowStatusOpt' + key"
              >
                <input
                  type="radio"
                  name="statusCode_input"
                  v-model="searchParam.ReviewId"
                  :value="item.statusId"
                />{{ item.statusCaption }}
              </div>
            </div>

            <div class="btn_group">
              <button
                type="button"
                class="btn btn-edit mr-2"
                @click="searchDataEvent"
              >
                {{ $t("Buttons.Query") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click.prevent="doQFMExport"
              >
                {{ $t("Buttons.ExportOrder") }}
              </button>
            </div>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import { qualityMixin } from "@/mixin/quality";
import { mapGetters } from "vuex";
export default {
  mixins: [qualityMixin],
  data() {
    return {
      searchParam: {
        // factoryId: "",
        VendorId: "",
        Factory: "",
        QFMNo: "",
        StartDateStart: "",
        StartDateEnd: "",
        MaterialNo: "",
        PONo: "",
        ProduceDateStart: "",
        ProduceDateEnd: "",
        ReviewId: "",
      },
      factoryList: this.$t("factoryQMList"), // 廠別 清單
      qfmStatusList: this.$t("qfmStatusList"), // 審核狀態 清單
    };
  },
  props: {},
  watch: {
    lang: function () {
      this.factoryList = this.$t("factoryQMList"); // 廠別 清單
      this.qfmStatusList = this.$t("qfmStatusList"); // 審核狀態 清單
    },
  },
  methods: {
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    //檢核條件
    checkSearchParam() {
      const { StartDateStart, StartDateEnd } = this.searchParam;
      let errMsg = "";
      if (StartDateStart && StartDateEnd) {
        if (StartDateStart > StartDateEnd) {
          errMsg = "立案日期區間錯誤，起始日不得大於終止日!";
        }
      }

      if (errMsg) {
        this.$alert(errMsg, "警告", { type: "warning" });
        return false;
      }
      return true;
    },

    // 進頁面顯示搜尋
    searchDataFirst() {
      // console.log('userInfo',this.$userInfo);
      this.searchParam = {
        ...this.searchParam,
      };
      this.$emit("doSearchEvent", this.searchParam);
    },

    //按鈕呼叫查詢觸發事件
    searchDataEvent() {
      if (!this.checkSearchParam()) {
        return;
      }

      this.searchParam = {
        ...this.searchParam,
      };
      this.$emit("doSearchEvent", this.searchParam);
    },

    // 匯出
    doQFMExport() {
      const vm = this;
      const api = `${this.$baseApiUrl}/QFM/QFMMasterDataExport`;
      const params = {
        ...vm.searchParam,
      };
      this.updateLoading(true);
      vm.axios.get(api, { params, responseType: "blob" }).then((response) => {
        if (response.data.type === "application/json") {
          let reader = new FileReader();
          reader.readAsText(response.data, "utf-8");
          reader.onload = () => {
            const { ErrorMessage } = JSON.parse(reader.result);
            this.updateLoading(false);
            Notification({
              title: "警告",
              message: ErrorMessage,
              type: "warning",
              duration: 5000,
            });
          };
        } else {
          this.updateLoading(false);

          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.href = url;
          a.download = "匯出總表.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
  },
  computed: {
    ...mapGetters(["lang"]),
  },
  mounted() {
    this.getCacheQueryParam("QfmUpload_QueryParam", this.searchParam);
    const userFactoryId = this.userFactoryId;
    if (userFactoryId) {
      this.searchParam.Factory = userFactoryId;
    }
    if (this.isMember) {
      const userInfo = this.$userInfo;
      this.searchParam.VendorId = userInfo.vendorId;
    } else {
      this.initMemberQMList();
    }

    this.$emit("doSearchEvent", this.searchParam);
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.CForminline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  > .form-group {
    margin-bottom: 0;
  }

  > div {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
    > p {
      margin-right: 1rem;
      margin-bottom: 0;
      width: 85px;
    }
    > input {
      margin: 0 0.5rem;
    }
    > div {
      margin: 0 0.5rem;
    }
  }
}

.purchase {
  width: 100%;
}

.btn-edit {
  background-color: #343b55;
  color: white;
}

@media screen and (max-width: 575px) {
  .CForminline {
    > div {
      display: block;
      width: 100%;
      > input {
        width: 100%;
        margin: 0;
      }
      > div {
        margin: 0;
        width: 100% !important;
      }
      .mx-datepicker {
        width: 100%;
      }
    }
  }
}
</style>
